import React, { useState } from 'react'
import './styles.scss'
import useSize from 'hooks/useSize'
import { scaleLinear } from 'd3-scale'
const dataY = 120
const annotationpositions = [
  [-30, -85],
  [25, 45],
  [55, 75]
]
const labelY = dataY +10
const padding = 40

export const PropertyViz = ({
  data,
  name,
  title,
  prop,
  unit,
  minmax,
  dir,
  annotate
}: {
  data: { pos: number; color: string; code: string }[]
  name: string
  title: string
  prop: string
  unit: string
  dir: 'normal' | 'reverse'
  minmax: [number, number] | [undefined, undefined]
  annotate?: [string, number][]
}) => {
  const [container, size] = useSize()
  const [hovered, sethovered] = useState<string | undefined>()

  const xScale = scaleLinear()
    .domain(dir === 'reverse' ? [100, 0] : [0, 100])
    .range([padding, size.width - padding])

  const valScale = scaleLinear()
    .domain([0, 100])
    .range(minmax as [number, number])
  return (
    <div className='PropVizContainer'>
      <div className='propvizicon'>
        <img src={require('images/icons/icons_' + prop + '.svg')} />
      </div>
      <div className='propvizchapter'> {title}</div>
      <div className='propviztitle'> {name}</div>
      <div className='propvizunit'> {unit}</div>
      <svg className='PropertyViz' ref={container}>
        <text x={0} y={labelY} className='label' textAnchor='start'>
          {((dir === 'reverse' ? minmax[1] : minmax[0]) || 0).toFixed(1)}
        </text>
        <text x={size.width} y={labelY} className='label' textAnchor='end'>
          {((dir === 'reverse' ? minmax[0] : minmax[1]) || 0).toFixed(1)}
        </text>
        {data &&
          data
            .sort((a, b) => a.pos - b.pos)
            .map((m, i) => {
              const annotation = annotate?.find(f => f[0] === m.code)
              const x = xScale(m.pos)
              let annopos = annotationpositions[0]
              if (hovered !== m.code && annotation) {
                annopos = annotationpositions[annotation[1]]
              }

              return (
                <g key={i} transform={`translate(${x},${dataY})`}>
                  {(annotation || hovered === m.code) && (
                    <g className='annotation'>
                      <line
                        x1={0}
                        y1={hovered !== m.code ? annopos[0] : annopos[0] - 30}
                        y2={hovered !== m.code ? 8: -50}
                      />
                      <text
                        y={annopos[1]-4}
                        textAnchor={
                          x < size.width * 0.2
                            ? 'start'
                            : x > size.width * 0.8
                            ? 'end'
                            : 'middle'
                        }
                        className='annotation'
                      >
                        <tspan x={0}>{m.name}</tspan>
                        {hovered === m.code && (
                          <tspan x={0} dy={18}>
                            {+valScale(m.pos).toFixed(1)}
                          </tspan>
                        )}
                      </text>
                    </g>
                  )}
                  {/* <image
                  transform={'translate(-13,-80)'}
                    href={require('images/flags/' + m.code + '.png')}
                    height='26'
                    width='26'
                  /> */}

                  <path
                    transform={`scale(1.25)`}
                    d={
                      'M12.5-22.7A12.3,12.3,0,0,1,6.6-12.3C4.2-11,1.4-8.5,1.4,0H-1.4c0-8.5-2.8-11-5.2-12.3a12.3,12.3,0,0,1-5.9-10.4A12.4,12.4,0,0,1,0-35,12.4,12.4,0,0,1,12.5-22.7Z'
                    }
                    fill={m.color}
                    stroke={'#fff'}
                    onMouseEnter={() => {
                      sethovered(m.code)
                    }}
                    onMouseLeave={() => {
                      sethovered(undefined)
                    }}
                  />
                </g>
              )
            })}
        <line x1={padding} y1={dataY+4} x2={size.width - padding} y2={dataY+4}  className='axis'/>
      </svg>
    </div>
  )
}
